import React from "react";
import styled from "styled-components";

/* ===== Styles ===== */

const SwitchGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

const SwitchInfo = styled.div`
  flex: 1;
`;

const SwitchTitle = styled.div`
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.25rem;
`;

const SwitchDescription = styled.div`
  font-size: 0.9rem;
  color: #333333;
  opacity: 0.7;
`;

const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
`;

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: ${({ checked }) => (checked ? "#4CAF50" : "#ccc")};
  transition: 0.3s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: #fff;
    transition: 0.3s;
    border-radius: 50%;
    transform: ${({ checked }) =>
      checked ? "translateX(26px)" : "translateX(0)"};
  }
`;

/* ===== Composant ===== */

const SwitchButton = ({
  title,
  description,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <SwitchGroup>
      <SwitchInfo>
        <SwitchTitle>{title}</SwitchTitle>
        {description && (
          <SwitchDescription>{description}</SwitchDescription>
        )}
      </SwitchInfo>

      <SwitchContainer>
        <SwitchInput
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <Slider checked={checked} />
      </SwitchContainer>
    </SwitchGroup>
  );
};

export default SwitchButton;